import styled from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import { Tooltip } from 'react-tooltip'

interface Props {
  isDiluted: boolean
  isEthRaise?: boolean
}

export const PsuedoButton = styled(Box)`
  border-radius: 3px;
  border: 1px solid var(--Midnight, #04111b);
  padding: 0 0.5rem;
  width: auto;
  flex: unset;
  h6,
  span.copy {
    font-weight: 500;
    color: #04111b;
    text-transform: uppercase;
  }
  img {
    filter: invert(1);
    max-width: unset;
  }
`

const DilutedButton = ({ isDiluted, isEthRaise }: Props) => {
  return (
    <PsuedoButton>
      <Box c g={8}>
        {isDiluted && (
          <img src="/img/icons/diluted-bolt.svg" alt="lightening bolt icon" />
        )}
        {isDiluted ? (
          <h6>diluted</h6>
        ) : (
          <span className="copy">not diluted</span>
        )}
        <img
          src="/img/icons/diluted-info.svg"
          alt="Diluted info tooltip icon"
          data-tooltip-id="diluted-tooltip"
        />
        <Tooltip
          id="diluted-tooltip"
          place="bottom-start"
          opacity={1}
          style={{ maxWidth: '230px', zIndex: 1 }}
        >
          <span>
            If the raise is oversubscribed all capital raised will be diluted,
            and you'll receive a portion of tokens and a portion of{' '}
            {isEthRaise ? 'ETH' : 'USDB'} refund
          </span>
        </Tooltip>
      </Box>
    </PsuedoButton>
  )
}

export default DilutedButton
